import React from 'react';
import Icon from '../../../components/AppIcon';

const SocialProofSection = () => {
  const cases = [
    {
      name: 'Familie Vermeer',
      location: 'Utrecht',
      quote: 'De GRP Wall Battery regelt alles automatisch. Met 20.000 cycli gegarandeerde levensduur en de grafeen-technologie weten we dat dit tientallen jaren meegaat. Onze energierekening is met €95 per maand gedaald.',
      result: 'Bespaart nu €1.140 per jaar',
      image: 'https://images.pexels.com/photos/1396122/pexels-photo-1396122.jpeg?auto=compress&cs=tinysrgb&w=400',
      imageAlt: 'Nederlandse woning met zonnepanelen en GRP Wall Battery thuisbatterij',
      type: 'Grafeen',
    },
    {
      name: 'Familie De Boer',
      location: 'Amsterdam',
      quote: 'De GRP LFP-batterij was in één dag geïnstalleerd. Het monitoringportaal geeft precies aan wat er met onze stroom gebeurt. Met 20.000 cycli levensduur en €85 besparing per maand is dit de beste investering die we hebben gedaan.',
      result: 'Bespaart nu €1.020 per jaar',
      image: 'https://images.pexels.com/photos/1029599/pexels-photo-1029599.jpeg?auto=compress&cs=tinysrgb&w=400',
      imageAlt: 'Vrijstaande woning in Amsterdam met GRP LFP thuisbatterij en zonnepanelen',
      type: 'LFP',
    },
  ];

  return (
    <section className="py-16 lg:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="inline-flex items-center space-x-2 text-primary bg-primary/10 px-3 py-1.5 rounded-full text-xs font-heading font-semibold uppercase tracking-wider mb-4">
            <Icon name="Users" size={12} />
            <span>Ervaringen</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-foreground leading-tight">
            Huiseigenaren gingen je voor
          </h2>
          <p className="mt-4 font-body text-muted-foreground">
            Echte ervaringen van mensen in vergelijkbare situaties.
          </p>
        </div>

        {/* Customer cases */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {cases?.map((c, i) => (
            <div key={i} className="bg-white border border-border rounded-2xl overflow-hidden shadow-elevation-1 hover:shadow-elevation-2 transition-shadow">
              <div className="relative h-44 overflow-hidden">
                <img src={c?.image} alt={c?.imageAlt} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                <div className="absolute bottom-3 left-4">
                  <span className="text-xs font-heading font-semibold bg-primary text-primary-foreground px-2.5 py-1 rounded-full">
                    GRP {c?.type}
                  </span>
                </div>
              </div>
              <div className="p-6 space-y-3">
                <div className="flex items-center space-x-1">
                  {[...Array(5)]?.map((_, j) => (
                    <Icon key={j} name="Star" size={14} className="text-amber-400 fill-amber-400" />
                  ))}
                </div>
                <blockquote className="text-sm font-body text-foreground italic leading-relaxed">
                  "{c?.quote}"
                </blockquote>
                <div className="flex items-center justify-between pt-2 border-t border-border">
                  <div>
                    <p className="text-sm font-heading font-semibold text-foreground">{c?.name}</p>
                    <p className="text-xs font-caption text-muted-foreground">{c?.location}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-xs font-caption text-muted-foreground">Resultaat</p>
                    <p className="text-sm font-heading font-semibold text-primary">{c?.result}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Interim: expert quote + Kiwa repeat */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Expert quote */}
          <div className="bg-white border border-border rounded-2xl p-6 shadow-elevation-1">
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                <Icon name="Quote" size={20} className="text-primary" />
              </div>
              <div>
                <blockquote className="text-sm font-body text-foreground italic leading-relaxed mb-3">
                  "GRP-thuisbatterijen combineren bewezen veiligheid met de nieuwste grafeen-technologie. Voor Nederlandse woningeigenaren is dit een toekomstbestendige keuze."
                </blockquote>
                <p className="text-sm font-heading font-semibold text-foreground">GRP Energy</p>
                <p className="text-xs font-caption text-muted-foreground">Leverancier GRP-thuisbatterijen</p>
              </div>
            </div>
          </div>

          {/* Kiwa repeat */}
          <div className="bg-blue-50 border border-blue-200 rounded-2xl p-6 shadow-elevation-1">
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0">
                <Icon name="Award" size={22} className="text-blue-600" />
              </div>
              <div>
                <p className="font-heading font-bold text-foreground mb-2">Onafhankelijk getest door Kiwa Primara</p>
                <p className="text-sm font-body text-muted-foreground leading-relaxed mb-3">
                  De GRP-grafeencel doorstond de volledige UN 38.3-testreeks. Eén onafhankelijk testinstituut zegt meer dan tien zelfgemaakte claims.
                </p>
                <a href="#" className="inline-flex items-center text-sm font-heading font-semibold text-blue-600 hover:text-blue-700">
                  Bekijk testrapport 24PP484-01
                  <Icon name="ExternalLink" size={13} className="ml-1.5" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <p className="text-xs font-caption text-muted-foreground mt-6 text-center italic">
          * Cases worden aangevuld na de eerste installaties. Nooit verzonnen reviews.
        </p>
      </div>
    </section>
  );
};

export default SocialProofSection;
